import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const exportStatisticTermQuantitative = async (payload) => {
    const { data } = await apiInstance.post(ENDPOINTS.STATISTIC_TERM_QUANTITATIVE, payload);
    return data
}